import { useGetProjectQuery } from 'features/entry-form-v2/data/useGetProjectQuery';
import { useFlag } from 'features/hooks/useFlag';
import { useParams } from 'react-router-dom';

export const useIsCodelistFeatureEnabled = () => {
	return useFlag('teamCoreCodelistCodelistEnabled');
};

export const useIsCodelistEnabledForProject = (): boolean => {
	const isCodelistFeatureEnabled = useIsCodelistFeatureEnabled();

	const { projectId, id } = useParams<{ projectId?: string; id?: string }>();

	const projectQuery = useGetProjectQuery(
		{ projectId: (projectId ?? id) as string },
		{ enabled: isCodelistFeatureEnabled && !!(projectId || id) }
	);

	return !!projectQuery.data?.project.keyId;
};
